@if (hasPeriodTypeInfoChartData) {
  <div class="period-type-info-chart-wrapper">
    <p class="period-type-info-chart-title period-type-info-chart-title-align" data-cy="period-type-title">Period type</p>
    @for (periodType of periodTypeInfoChartData | keyvalue: originalOrder; track periodType; let firstPeriod = $first) {
      @switch (currentView) {
        @case (periodViewTabs.BUNDLES) {
          @for (bundle of periodType.value.bundlesList; track bundle; let firstBundle = $first; let index = $index) {
            <ng-container
                                *ngTemplateOutlet="bundlesTimeline;
                                context: {
                                    bundle: bundle,
                                    timePeriod: periodType.value.timePeriod,
                                    periodType: periodType.value.periodType,
                                    firstPeriod: firstPeriod,
                                    firstBundle: firstBundle,
                                    index: index
                                }">
            </ng-container>
          }
        }
        @case (periodViewTabs.SETTLEMENTS) {
          <ng-container
                            *ngTemplateOutlet="settlementsTimeline;
                               context: {
                                settlements: periodType.value.settlementsList,
                                timePeriod: periodType.value.timePeriod,
                                periodType: periodType.value.periodType
                            }">
          </ng-container>
        }
      }
    }
  </div>
} @else {
  @if (hasNoResultBody) {
    <div class="period-type-info-chart-wrapper noPeriodResults">
      <div class="noPeriodResults-wrapper">
        <img src="/assets/img/search/search-no-results.svg" height="51px" width="51px"/>
        <div class="noPeriodResults-message">There are no results for your search</div>
      </div>
    </div>
  } @else {
    <div class="period-type-info-chart-wrapper noPeriodResults">
      <div class="noPeriodResults-wrapper">
        <span class="iwp-icon-iwp_task noPeriodResults-icon" data-cy="noPeriodResults-icon"></span>
        <div class="noPeriodResults-message" data-cy="noPeriodResults-text">The period list is empty</div>
      </div>
    </div>
  }
}

<ng-template #bundlesTimeline
  let-bundle="bundle"
  let-timePeriod="timePeriod"
  let-periodType="periodType"
  let-firstPeriod="firstPeriod"
  let-firstBundle="firstBundle"
  let-index="index">
  @if (firstBundle) {
    <div class="period-type-info-chart-dot-wrapper" [attr.lineIdentifier]="getLineIdentifier(bundle)">
      <div class="period-type-info-chart-info">
        <div class="period-type-info-chart-dot">
          <app-tooltip [message]="periodDateTooltip(timePeriod)" [dynamic]="false">
            <div [ngClass]="periodType.code" class="period-type-dot" data-cy="period-type-dot"></div>
          </app-tooltip>
        </div>
        <span class="period-type-info-chart-title">{{periodType.name}}</span>
      </div>
      <span class="period-type-dot-line" [ngClass]="{'period-type-dot-line-first-period': firstPeriod}"></span>
    </div>
  } @else {
    <ng-container *ngTemplateOutlet="lineTemplate; context: {identifier: bundle, index: index}"></ng-container>
  }

</ng-template>

<ng-template #settlementsTimeline
  let-settlements="settlements"
  let-timePeriod="timePeriod"
  let-periodType="periodType">
  @for (settlementBundles of settlements | keyvalue: originalOrder; track settlementBundles; let firstBundle = $first) {
    @for (settlementElement of settlementBundles.value; track settlementElement; let index = $index; let firstSettlement = $first) {
      @if (firstBundle && firstSettlement) {
        <div class="period-type-info-chart-dot-wrapper" [attr.lineidentifier]="getLineIdentifier(settlementBundles.value[index])">
          <div class="period-type-info-chart-info-bundles">
            <div class="period-type-info-chart-dot">
              <app-tooltip [message]="periodDateTooltip(timePeriod)" [dynamic]="false">
                <div [ngClass]="periodType.code" class="period-type-dot" data-cy="period-type-dot"></div>
              </app-tooltip>
            </div>
            <span class="period-type-info-chart-title">{{periodType.name}}</span>
          </div>
          <div class="period-type-info-chart-info bundle-info">
            <div class="period-type-info-chart-dot bundles">
              <div class="period-type-dot bundles" [ngClass]="settlementBundles.key.status" data-cy="period-type-dot"></div>
            </div>
            <div class="period-type-info-chart-title-bundles">{{settlementBundles.key.bundleNumber}}</div>
          </div>
          <span class="period-type-dot-line bundles"></span>
        </div>
      } @else {
        <ng-container *ngTemplateOutlet="lineTemplateBundle; context: {identifier: settlementBundles.value[index], index: index, bundleInfo: settlementBundles.key}"></ng-container>
      }
    }
  }
</ng-template>




<ng-template #lineTemplate
  let-identifier="identifier"
  let-index="index">
  <div class="bundle-period-chart" [attr.lineIdentifier]="getLineIdentifier(identifier)" [attr.data-cy]="periodChartLineDataCy(index)">
    <span class="period-type-dot-line"></span>
  </div>
</ng-template>


<ng-template #lineTemplateBundle
  let-identifier="identifier"
  let-bundleInfo="bundleInfo"
  let-index="index">
  <div class="bundle-period-chart" [attr.lineIdentifier]="getLineIdentifier(identifier)" [attr.data-cy]="periodChartLineDataCy(index)">
    @if (index === 0) {
      <div class="period-type-info-chart-info bundle-info bundle-info-single">
        <div class="period-type-info-chart-dot bundles">
          <div class="period-type-dot bundles" [ngClass]="bundleInfo.status" data-cy="period-type-dot"></div>
        </div>
        <div class="period-type-info-chart-title-bundles">{{bundleInfo.bundleNumber}}</div>
      </div>
    }
    <span class="period-type-dot-line bundles"></span>
  </div>
</ng-template>
